import React, { useState,useEffect } from 'react';
import queryString from 'query-string';
import {comma,instance} from './common';
import parse from 'html-react-parser';
import Bottom_menu from './Bottom_menu';

function Product_detail({ history, location, match }){
    const query = queryString.parse(location.search);
    console.log('query : ', query)
    const {pr_id} = query;

    let session = JSON.parse(window.sessionStorage.result);
    let {u_id} = session;

    const [data, setData] = useState([]);
    const [price,setPrice] = useState(0);
    const [d_price,setDPrice] = useState(0);

    useEffect(() => {

        const fetchData = async () => {
            instance.post('/product/id', {pr_id:pr_id}).then(function (res) {
                setData(res.data);
                setPrice(res.data[0].daeri_price);
                setDPrice(res.data[0].daeri_price);

            });

        };
        fetchData();

    }, []);

    console.log('data : ', data);

    const [count, setCount] = useState(1);

    const countChange = (e) => {
        const {name} = e.target;

        if(name == 'minus'){
            if(count -1 < 1){
                
            }else{
                setCount(count-1);
                setPrice(d_price*(count-1))
            }
            
        }else if(name == 'plus'){
            setCount(count+1)
            setPrice(d_price*(count+1))
        }

        
    }


    const lineHeight = {
        lineHeight :'27.5px'
    }


    const goCart = () => {
        
        const obj = {pr_id:pr_id,u_id:u_id,pr_count:count};
        const fetchData = async () => {
            instance.post('/p_cart/insert',{obj:obj}).then(function(res){
                alert(res.data.msg);
            });
        
        };
    
        fetchData();
        
    
    }

    const direct = () => {
        const obj = {pr_id:pr_id,u_id:u_id,pr_count:count};
        const fetchData = async () => {
            instance.post('/p_cart/direct',{obj:obj}).then(function(res){
                history.push('/order-sheet');
            });
        
        };
    
        fetchData();
    }
    return (
        <>
            <div className="container pt-5" style={{paddingBottom:'100px'}}>
                {
                    data.map(v =>
                        <>
                        <div className="row p-0" key={v.pr_id}>
                            <div className="col-12">
                                <div className="product-detail-bg" style={{background:'url(\''+v.pr_img+'\')'}}></div>
                            </div>
                            <div className="col-12 mt-2">
                                <h4 className="font-weight-bold text-secondary mt-2 mb-0">{v.pr_name}</h4>
                                <h4 className="font-weight-bold mt-2">{comma(v.daeri_price)} 원</h4>
                            </div>

                            <div className="col-12 mt-5">
                                <h3 className="font-weight-bold mt-2 mb-0">상세설명</h3>
                                <div className="mt-3">
                                    {
                                        parse(v.pr_content)
                                    }
                                </div>
                            </div>
                            
                        </div>

                        <div className="row p-0 border-top">
                            <div className="col-7 mt-3 mb-3">
                                <h3 className="font-weight-bold d-inline-block" style={{lineHeight :'32px'}}>수량</h3>
                                <div className="btn-group ml-3 d-inline-block mb-2" role="group" aria-label="Basic example">
                                    <button type="button" className="pl-4 pr-4 btn btn-outline-secondary" name="minus" onClick={countChange}>-</button>
                                    <button type="button" className="pl-4 pr-4 btn btn-outline-secondary">{count}</button>
                                    <button type="button" className="pl-4 pr-4 btn btn-outline-secondary" name="plus" onClick={countChange}>+</button>
                                </div>
                                
                            </div>
                            <div className="col-5 mt-3 mb-3 text-right pl-0">
                                <h3 className="font-weight-bold d-inline-block" style={lineHeight}>{comma(price)} 원</h3>
                            </div>
                            <div className="col-6">
                                <span className="pt-3 pb-3 btn btn-outline-secondary d-block" onClick={direct}>바로구매</span>
                            </div>
                            <div className="col-6">
                                <span className="pt-3 pb-3 btn btn-primary d-block" onClick={goCart}>장바구니에 담기</span>
                            </div>
                        </div>
                        </>
                    )
                    
                }
            </div>
            <Bottom_menu />
        </>
    )
}

export default Product_detail;